import { LeadCard } from './LeadCard';
import type { Lead } from '../../api/client';

interface BoroughColumnProps {
  borough: string;
  leads: Lead[];
  onLeadClick?: (lead: Lead) => void;
}

export function BoroughColumn({ borough, leads, onLeadClick }: BoroughColumnProps) {
  const newCount = leads.filter((l) => l.is_new).length;

  return (
    <div className="flex flex-col min-w-[320px] max-w-[400px]">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-brand-sand p-3 border-b border-card-border">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-font-primary">{borough}</h3>
          <div className="flex items-center space-x-2">
            {newCount > 0 && (
              <span className="px-2 py-0.5 bg-brand-secondary text-brand-primary rounded-full text-xs font-semibold">
                {newCount} new
              </span>
            )}
            <span className="text-sm text-font-secondary">{leads.length} total</span>
          </div>
        </div>
      </div>

      {/* Cards */}
      <div className="flex-1 overflow-y-auto p-3 space-y-3">
        {leads.length === 0 ? (
          <div className="text-center py-8 text-font-secondary">
            No leads in this area
          </div>
        ) : (
          leads.map((lead) => (
            <LeadCard
              key={lead.id}
              lead={lead}
              onClick={() => onLeadClick?.(lead)}
            />
          ))
        )}
      </div>
    </div>
  );
}
